import { Link } from '@tanstack/react-router'
import { SplitSection } from '@/components/marketing/section'

const compareLinks = [
  { name: 'UptimeRobot', to: '/compare/uptimerobot' },
  { name: 'Pingdom', to: '/compare/pingdom' },
  { name: 'Better Stack', to: '/compare/betterstack' },
  { name: 'Datadog', to: '/compare/datadog' },
  { name: 'HetrixTools', to: '/compare/hetrixtools' },
  { name: 'Uptime Kuma', to: '/compare/uptime-kuma' },
  { name: 'StatusCake', to: '/compare/statuscake' },
  { name: 'Checkly', to: '/compare/checkly' },
]

export function Compare({ tone = 'raised' }: { tone?: 'default' | 'raised' }) {
  return (
    <SplitSection tone={tone} title="Switching from something else?" lead="Honest comparisons: where we win, where we don’t, and who shouldn’t use Uptrack.">
          <ul className="flex flex-wrap gap-2.5">
            {compareLinks.map((c) => (
              <li key={c.name}>
                <Link
                  to={c.to}
                  className="inline-flex h-10 items-center rounded-md border border-border bg-background px-4 text-sm font-medium text-foreground transition-colors hover:border-primary"
                >
                  Uptrack vs {c.name}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-7 text-[15px] text-body">
            Prefer a second opinion? Ask{' '}
            <a href="https://chatgpt.com/?q=Compare+Uptrack+vs+UptimeRobot+for+uptime+monitoring" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-4">ChatGPT</a>,{' '}
            <a href="https://claude.ai/new?q=Compare+subscription+uptime+monitors+with+30+second+checks" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-4">Claude</a> or{' '}
            <a href="https://perplexity.ai/search?q=Which+uptime+monitor+checks+from+24+locations+before+alerting" target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-4">Perplexity</a>.
            We publish{' '}
            <a href="/llms.txt" className="text-primary underline underline-offset-4">llms.txt</a> so they have the full picture.
          </p>
        
    </SplitSection>
  )
}
